<template>
  <div class="listing-page">
    <div class="publisher-banner" :style="{ backgroundColor: page.color }"></div>
    <div class="row">
      <div class="columns small-12 medium-10">
        <figure class="publisher-logo">
          <nuxt-img :src="page.logo" alt="Publisher logo" width="200" height="200" format="webp" />
        </figure>
      </div>
    </div>

    <header class="header">
      <div class="row">
        <div class="columns small-12 medium-10">
          <div class="subheader">Teaching Resource Publisher</div>
          <h1>{{ page.title }}</h1>

          <p>{{ page.description }}</p>

          <ul class="social-links inline-list">
            <li v-for="item in page.social" :key="item.name">
              <a :href="item.link" :title="'Follow us on ' + item.name" class="button button-link">
                <svg role="img" :aria-label="item.name" class="icon text-mute">
                  <use
                    v-bind="{
                      'xlink:href': '/images/fa-icons.svg#' + item.icon,
                    }"
                  ></use>
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>

    <resources-list
      :pagination="true"
      :params="page.params"
      :available-filters="availableFilters"
      :col-count="5"
      :filter-dropdown-count="3"
    />
  </div>
</template>

<script>
/* List resources by publisher
 *
 * @parent:
 * @requests:
 * @events:
 * @props:
 * @components: ExpandableDescription, ResourcesList
 * @methods:
 */

import ResourcesList from '~/components/resource/ResourcesList.vue';

export default {
  name: 'Publisher',
  components: {
    ResourcesList,
  },
  async asyncData({ params, route, error }) {
    const data = { page: null, errorBlogs: null };

    try {
      // Load page content from a JSON file - only works with asyncData, not fetch
      const page = await import('@/data/publisher/' + params.slug + '.json');

      if (page) {
        data.page = page;
        data.title = page.title;
        data.description = page.meta_description;
      }

      return data;
    } catch (err) {
      // No JSON file matching the route
      error({ statusCode: 404, message: err.message, path: route.path });
    }
  },
  data() {
    return {
      title: 'Teaching Resources by Publisher',
      description: 'Browse resources by Publisher',
      availableFilters: [
        'types',
        'learning_areas',
        'resource_types',
        'year_levels',
        'availability',
        'file_formats',
        'publishers',
      ],
    };
  },
  jsonld() {
    return this.$jsonSchemaPage(this.title, this.$route.path);
  },
  head() {
    return {
      title: this.title,
      meta: [
        { hid: 'title', name: 'title', content: this.title },
        { hid: 'description', name: 'description', content: this.description },
        { hid: 'og-title', property: 'og:title', content: this.title },
      ],
      link: this.$hrefLangsPage(this.$route),
    };
  },
};
</script>

<style scoped lang="scss">
.publisher-banner {
  height: 7rem;
  width: 100%;
}

.publisher-logo {
  display: inline-block;
  margin-top: -3rem;
  margin-bottom: -1rem;
  padding: $base-padding-half;
  position: relative;
  line-height: 0;
  z-index: 5;

  img {
    background: #fff;
    border-radius: 50%;
    border: 1px solid $grey-200;
  }
}

.social-links {
  .button {
    padding: $base-padding-half;
  }

  .icon {
    height: 1.4rem;
    width: 1.4rem;
  }
}

// Hack to hide the Publishers filter in the More Filters dropdown
:deep(.filter-more-list) {
  > :last-child {
    display: none;
  }
}
</style>
